import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useService } from "../../ioc-container/hooks.js";
import "../../ioc-container/inversifyProvider.js";
import { useAsyncActionState } from "../async-actions/hooks.js";
import "../async-actions/actions.js";
import "../../intl/shared-resources/serverResponse.js";
import "rxjs";
import "rxjs/operators";
import "typesafe-actions";
import "react";
import "react-oidc-context";
import "react-router";
import "oidc-client-ts";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "redux-observable";
import "../../api/types.js";
import "immer";
import "moment-timezone";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../async-action/action.js";
import "../error-handling/action.js";
import "../actions.js";
import "../async-actions/reducers.js";
import { downloadActions } from "./actions.js";
function useDownload({
  filename,
  total,
  filter,
  mode,
  strategySymbol,
  headersLocalization,
  keys,
  worksheetKeys = keys,
  hasSummary
}) {
  const dispatch = useDispatch();
  const { isProgress } = useAsyncActionState(downloadActions.fetchDownloadData);
  const { formatMessage } = useIntl();
  const downloadStrategy = useService(strategySymbol);
  const localizedHeaders = keys?.reduce(
    (result, k) => {
      result[k] = formatMessage(headersLocalization[k]);
      return result;
    },
    {}
  );
  function handleDownload() {
    dispatch(
      downloadActions.startDownload({
        keys,
        worksheetKeys,
        filter,
        headers: localizedHeaders,
        total,
        filename: typeof filename === "string" ? filename : formatMessage(filename),
        strategy: downloadStrategy,
        mode,
        hasSummary
      })
    );
  }
  return { handleDownload, isProgress };
}
export {
  useDownload
};
//# sourceMappingURL=hooks.js.map
